var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSapceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 65,
    viewBox: "0 0 87 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2283 5.75628L34.4104 0.812829L9.84055 24.6152C4.8741 29.4265 4.87114 37.3921 9.83402 42.2071L30.7892 62.5378L63.5313 30.749L54.6033 21.5481L49.5924 26.5065L53.844 30.9011L41.3348 43.7314C35.7337 49.4763 26.5082 49.5054 20.871 43.796C15.2835 38.1369 15.3709 29.011 21.0658 23.46L39.2283 5.75628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1169 59.6227L51.9311 64.5698L76.5057 40.7986C81.4807 35.9862 81.4839 28.0107 76.5127 23.1944L55.5342 2.86929L22.8327 34.6118L31.7538 43.8194L36.7684 38.8648L32.5201 34.4669L45.0389 21.646C50.6443 15.9053 59.8698 15.8831 65.5027 21.5968C71.086 27.26 70.9917 36.3859 65.2927 41.9326L47.1169 59.6227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapceLogo);
export default __webpack_public_path__ + "static/media/sapceLogo.50a65ee7895099b071af8663ef0131a6.svg";
export { ForwardRef as ReactComponent };